/**
 * PayrollConfigPage — Bérszámfejtés admin konfiguráció
 * PAY-12: Adókulcsok CRUD + Műszakminták (HR API)
 * Route: /payroll/config
 * RBAC: SUPER_ADMIN + PARTNER_OWNER (server enforces, no client guard)
 */

import { useTranslation } from '@kgc/i18n';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@kgc/ui';
import { ShiftPatternEditor } from '../components/ShiftPatternEditor';
import { TaxRateEditor } from '../components/TaxRateEditor';

export function PayrollConfigPage() {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto px-4 py-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">{t('payroll.config.title')}</h1>
        <p className="text-sm text-muted-foreground mt-1">{t('payroll.config.subtitle')}</p>
      </div>

      <Tabs defaultValue="taxRates">
        <TabsList>
          <TabsTrigger value="taxRates">{t('payroll.config.taxRates')}</TabsTrigger>
          <TabsTrigger value="shifts">{t('payroll.config.shifts')}</TabsTrigger>
        </TabsList>

        <TabsContent value="taxRates">
          <TaxRateEditor />
        </TabsContent>

        <TabsContent value="shifts">
          <ShiftPatternEditor />
        </TabsContent>
      </Tabs>
    </div>
  );
}
